import React, { Component } from 'react';
import '../styles/introduction.scss';
import '../styles/parallax.scss';

export default class Introduction extends Component {
  render() {
    return (
      <div className="introduction">
        <div className="introduction__content">
          <h2 className="introduction__name">
            DENNIS ALDANA
          </h2>
          <div className="introduction__tagline">
            Frontend developer
          </div>
          <div className="introduction__location">
            Guatemala
          </div>
          <div className="introduction__icons">
            <a href="mailto:dennis.aldana+website@gmail.com" target="_blank"><i className="fa fa-envelope icon"></i></a>          
            <a href="http://github.com/denn1s" target="_blank"><i className="fa fa-github icon"></i></a>
            <a href="http://linkedin.com/in/dennisaldana" target="_blank"><i className="fa fa-linkedin-square icon"></i></a>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Introduction.js